import { render, staticRenderFns } from "./Mediatheke.vue?vue&type=template&id=8b97bdae&scoped=true"
import script from "./Mediatheke.vue?vue&type=script&lang=js"
export * from "./Mediatheke.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b97bdae",
  null
  
)

export default component.exports